export default "__VITE_ASSET__81b7fb9a__"